import { render } from "./Formula.vue?vue&type=template&id=7febc07d"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.16.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__